<div class="info-page-container">
  <!-- Information Card -->
  <div class="info-card mb-5">
    <!-- Header -->
    <div class="info-header">
      <h2 class="info-title">{{ "information" | translate }}</h2>
      <div
        class="header-actions"
        *ngIf="isSystemAdmin && !isEditMode && !isLoading"
      >
        <button class="btn btn-edit" (click)="enterEditMode()">
          {{ "edit" | translate }}
        </button>
      </div>
    </div>

    <!-- View Mode (All Users) -->
    <div class="info-content" *ngIf="!isEditMode && !isLoading">
      <div *ngIf="infoPage" class="content-display">
        <h3 class="content-title">{{ infoPage.title }}</h3>
        <div class="content-body" [innerHTML]="infoPage.content"></div>
        <div class="content-footer">
          <small class="text-muted">
            {{ "createdDate" | translate }}:
            {{ infoPage.createdDate | date: "medium" }}
          </small>
        </div>
      </div>
      <div *ngIf="!infoPage" class="no-content">
        <p class="text-muted">{{ "infoPage.noContent" | translate }}</p>
        <button
          *ngIf="isSystemAdmin"
          class="btn btn-primary"
          (click)="enterEditMode()"
        >
          {{ "infoPage.createNew" | translate }}
        </button>
      </div>
    </div>

    <!-- Edit Mode (System Admin Only) -->
    <div class="info-edit" *ngIf="isEditMode && !isLoading">
      <div class="edit-form">
        <!-- Language Selector -->
        <div class="form-group mb-3">
          <label for="language" class="form-label">{{
            "profile.language" | translate
          }}</label>
          <app-select
            [items]="languageOptions"
            bindLabel="label"
            bindValue="value"
            [(selected)]="editLanguage"
            (selectedChange)="onLanguageChange()"
            [clearable]="false"
            [multiple]="false"
          ></app-select>
        </div>

        <!-- Title Input -->
        <div class="form-group mb-3">
          <label for="title" class="form-label">{{
            "infoPage.title" | translate
          }}</label>
          <input
            type="text"
            id="title"
            class="form-control"
            [(ngModel)]="editTitle"
            [placeholder]="'infoPage.titlePlaceholder' | translate"
          />
        </div>

        <!-- Content Editor -->
        <div class="form-group mb-3">
          <label for="content" class="form-label">{{
            "infoPage.content" | translate
          }}</label>
          <div class="ngx-editor-wrapper">
            <ngx-editor-menu
              [editor]="editor"
              [toolbar]="toolbar"
            ></ngx-editor-menu>
            <ngx-editor
              [editor]="editor"
              [(ngModel)]="editContent"
              [placeholder]="'infoPage.contentPlaceholder' | translate"
            >
            </ngx-editor>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="edit-actions">
          <button class="btn btn-secondary" (click)="cancelEdit()">
            {{ "cancel" | translate }}
          </button>
          <button class="btn btn-primary" (click)="saveInfoPage()">
            {{ "save" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Version Management Card -->
  <div class="info-card version-card" *ngIf="!isEditMode">
    <div class="info-header">
      <h2 class="info-title">{{ "VersionManagement.Title" | translate }}</h2>
      <div class="header-actions">
        <button class="btn btn-edit" (click)="navigateToCreateVersion()">
          {{ "VersionManagement.History" | translate }}
        </button>
      </div>
    </div>
    <div class="info-content">
      <div class="d-flex align-items-center gap-3">
        <i class="fa-solid fa-code-branch fa-2x text-primary"></i>
        <div class="d-flex flex-column">
          <!-- <p class="mb-0 text-muted">{{ "VersionManagement.Description" | translate }}</p> -->

          <div
            *ngIf="latestVersionInfo"
            class="d-flex align-items-center gap-3 mt-3"
          >
            <div class="detailed-version-card flex-grow-1 m-0">
              <div class="d-flex align-items-center flex-wrap gap-3 w-100">
                <span class="version-name">{{
                  latestVersionInfo.versionName
                }}</span>

                <span class="version-badge">{{
                  latestVersionInfo.versionNumber
                }}</span>

                <span class="version-date text-muted d-flex align-items-center">
                  {{ latestVersionInfo.releaseDate | date: "mediumDate" }}
                </span>

                <span
                  class="stage-badge ms-auto d-flex d-md-none"
                  *ngIf="latestVersionInfo.developmentStage !== undefined"
                >
                  {{
                    getStageLabel(latestVersionInfo.developmentStage)
                      | translate
                  }}
                </span>

                <button
                  *ngIf="latestVersionInfo.pdfPath"
                  class="btn btn-sm btn-view-pdf"
                  (click)="togglePdf($event); $event.stopPropagation()"
                >
                  <i
                    class="fa-regular"
                    [ngClass]="showPdf ? 'fa-eye-slash' : 'fa-file-lines'"
                  ></i>
                  {{ showPdf ? "Hide PDF" : "Changelog" }}
                </button>
              </div>
            </div>

            <span
              class="stage-badge d-none d-md-flex"
              *ngIf="latestVersionInfo.developmentStage !== undefined"
            >
              {{
                getStageLabel(latestVersionInfo.developmentStage) | translate
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- PDF Modal -->
<div class="modal-backdrop fade show" *ngIf="showPdf"></div>
<div
  class="modal fade show d-block"
  *ngIf="showPdf"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
>
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content bg-dark-theme">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title text-light">
          {{ latestVersionInfo?.versionName }} -
          {{ latestVersionInfo?.versionNumber }}
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          (click)="togglePdf()"
        ></button>
      </div>
      <div class="modal-body p-0">
        <iframe
          *ngIf="safePdfUrl"
          [src]="safePdfUrl"
          width="100%"
          height="800px"
          frameborder="0"
        >
        </iframe>
      </div>
    </div>
  </div>
</div>
